'use client'
import { useMutation } from '@tanstack/react-query'
import { useRouter } from 'next/navigation'

import { authClient } from '@/lib/auth-client'
import { db } from '@/local-db/db'
import { routes } from '@/routes'

const useSignOut = () => {
  const router = useRouter()
  return useMutation({
    mutationFn: async () => authClient.signOut(),
    onSuccess: async () => {
      await db.delete({
        disableAutoOpen: false,
      })
      localStorage.clear()
      router.push(routes.signIn)
    },
  })
}

export default useSignOut
